import { required, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    data: {
      inputs: {
        required: helpers.withMessage(i18n.global.t('Please add at least one input.'), required),
      },
      outputs: {
        required: helpers.withMessage(i18n.global.t('Please add at least one output.'), required),
      }
    }
  }
};
